import { useContext } from 'react'
import { createCtx, InitializableProviderProps } from '../../../../context/_createCtx'
import { FullScreenActionDialogContextValues, FullScreenActionDialogProps } from '../_props'

export const defaultFullScreenActionDialogValues: FullScreenActionDialogContextValues = {
    title: '',
    cancelProps: {
        label: 'Annuler',
        action: () => undefined,
    },
    isError: false,
    isLoading: false,
    loadingMessage: undefined,
}

const [ctx, provider] = createCtx(defaultFullScreenActionDialogValues)

export const FullScreenActionDialogContextProvider = ({
    children,
    initialValues,
}: InitializableProviderProps<FullScreenActionDialogProps>) => provider({ children, initialValues })

export const useFullScreenActionDialogContext = () => useContext(ctx)
